import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Letters and space only: A–Z / a–z 
export const letterValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  return /^[A-Za-z ]+$/.test(value) ? null : { letters: true };
};

// Numbers only (integer) 
export const numberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
    if (!value) return null; // allow empty value
  return /^[0-9]+$/.test(value) ? null : { number: true };
};


//letter and number both
export const alphanumericValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
    if (!value) return null; // allow empty value
  return /^[A-Za-z0-9 ]+$/.test(value) ? null : { alphanumeric: true };
};

